import { IPreferences } from "@/androidPlugins/IPreferences"

const OVERRIDE_MID_PREFERENCES_KEY = "overrideMid"

const getOverrideMid = async () => {
  if (import.meta.env.VITE_ENVIRONMENT === "production") {
    throw new Error(
      "'getOverrideMid' should not be called in a production build"
    )
  }

  const { value } = await IPreferences.get({
    key: OVERRIDE_MID_PREFERENCES_KEY,
  })

  return value || null
}

const setOverrideMid = async (value: string | null) => {
  if (import.meta.env.VITE_ENVIRONMENT === "production") {
    throw new Error(
      "'setOverrideMid' should not be called in a production build"
    )
  }

  await IPreferences.set({
    key: OVERRIDE_MID_PREFERENCES_KEY,
    value: value ?? "",
  })
}

/**
 * A composable designed for use only in a NON-PRODUCTION environment,
 * allowing the user to override the device's mid and pair to any client.
 */
export const useOverrideMid = () => ({
  getOverrideMid,
  setOverrideMid,
})
